/**
 * Created by laszlo.czondor on 2017. 12. 11.
 */
import { SZOLGALTATASOK } from './urls';

const DEFAULT_COMMITMENT_PERIOD_ID = 1; // hűségidő nélkül

function getServices(commitmentPeriodId = DEFAULT_COMMITMENT_PERIOD_ID, serviceTypePath) {
	let path = `${SZOLGALTATASOK}${serviceTypePath ? serviceTypePath : ''}`;

	return window.axios.get(`${path}?husegidoId=${commitmentPeriodId}`);
}

export default getServices;



// WEBPACK FOOTER //
// ../source/common/api/get-services.js